import {PointsPolygon} from "../../../../../../helpers/geometry/PointsPolygon";
import {Point} from "../../../../../../helpers/geometry/Point";
import {PolygonClippingFacade} from "../../../../../../helpers/geometry/PolygonClippingFacade";
import {
  calculateIntersection,
  getAngleBetweenSegments,
  getLineEquation,
  getPerpOffset
} from "../../../../../../helpers/coordinatesHelper";

export function getOffsetShapePoints(outerShapePoints, offsetDistance) {
  const offsetPoints = getOffsetShapePointsVsIntersections(outerShapePoints, offsetDistance, 1);
  const offsetPointsReversed = getOffsetShapePointsVsIntersections(outerShapePoints.reverse(), offsetDistance, 1, true);
  const shapePoints = [...offsetPoints, ...offsetPointsReversed];
  const polygon = new PointsPolygon(shapePoints.map((p) => new Point(Math.round10(p.x, -3), Math.round10(p.y, -3))));
  const resultPolygons = PolygonClippingFacade.simplifyPolygon(polygon);

  if (resultPolygons.length === 0) {
    console.log('No polygons found after union.');
  } else {
    const largest = PolygonClippingFacade.pickLargestPolygon(resultPolygons);
    largest.points.pop();
    return largest.points;
  }

  return []
}

const isApproximately = (value, target, epsilon = 1) => Math.abs(value - target) < epsilon;

export function getOffsetShapePointsVsIntersections(points, offsetDistance = 10, direction = 1) {
  /*
   * This function offsets a polyline defined by "points"
   * by "offsetDistance" to the left (direction=+1) or to the right (direction=-1).
   * Returns an array of offset points.
   *
   * For very sharp angles (< 90°), it uses a simple "bevel" approach
   * by adding two points instead of a single intersection.
   */

  if (!points || points.length < 2) return [];

  const offsetPoints = [];

  // 1) Offset the first point
  offsetPoints.push(
    getPerpOffset(points[0], points[1], offsetDistance, direction)
  );

  // 2) Process middle points
  for (let i = 1; i < points.length - 1; i++) {
    const prev = points[i - 1];
    const curr = points[i];
    const next = points[i + 1];

    // Build offset lines for (prev->curr) and (curr->next)
    // We'll offset them, then intersect.
    const linePrevStart = getPerpOffset(curr, prev, offsetDistance, -direction);
    const linePrevEnd   = getPerpOffset(prev, curr, offsetDistance, direction);
    const linePrevEq    = getLineEquation(linePrevStart, linePrevEnd);

    const lineNextStart = getPerpOffset(curr, next, offsetDistance, direction);
    const lineNextEnd   = getPerpOffset(next, curr, offsetDistance, -direction);
    const lineNextEq    = getLineEquation(lineNextStart, lineNextEnd);

    // Intersection
    const intersect = calculateIntersection(linePrevEq, lineNextEq);
    const angleDeg  = getAngleBetweenSegments(prev, curr, next);

    if (!intersect) {
      // Fallback if lines are parallel
      //offsetPoints.push(linePrevStart);
      offsetPoints.push(linePrevStart, lineNextStart);
      continue;
    }

    if (Math.abs(angleDeg) <= 1 || Math.abs(angleDeg) >= 359) {
      offsetPoints.push(linePrevStart, lineNextStart);

    } else if (angleDeg < 90) {
      // We push the ends of each offset segment to form two parallel lines

      // 1) Dull corner
      // let clampPrev;
      // let clampNext;
      // if (isPointsReversed) {
      //   clampPrev = getPointOnTheLine(lineNextStart, lineNextEnd, offsetDistance);
      //   clampNext = getPerpendicularPoint(clampPrev, lineNextEnd, -offsetDistance * 2);
      // } else {
      //   clampNext = getPointOnTheLine(linePrevStart, linePrevEnd, offsetDistance);
      //   clampPrev = getPerpendicularPoint(clampNext, linePrevEnd, offsetDistance * 2);
      // }
      //offsetPoints.push(clampNext, clampPrev);

      // 2) Dull corner v2
      //offsetPoints.push(linePrevStart, lineNextStart);

      //3) Sharp corner
      offsetPoints.push(intersect);

    } else if (angleDeg > 270) {
      //offsetPoints.push(intersect);
      offsetPoints.push(linePrevStart, lineNextStart);

    // if lines are parallel then we can push any perpendicular point
    } else if (isApproximately(angleDeg, 180) || isApproximately(angleDeg, -180)) {
      offsetPoints.push(linePrevEnd);
      //offsetPoints.push(lineNextStart); //same point
    } else {
      // Normal intersection
      offsetPoints.push(intersect);
    }
  }

  // 3) Offset the last point
  const n = points.length - 1;
  offsetPoints.push(
    getPerpOffset(points[n], points[n - 1], offsetDistance, -direction)
  );

  return offsetPoints;
}
